import { Component, DestroyRef, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OrderWorkflowFacade } from '@features/client/order-workflow/facades/order-workflow.facade';
import { OrderWorkflowStep } from '@features/client/order-workflow/enums/order-workflow-step.enum';
import { delay, first } from 'rxjs/operators';
import { VaporFile } from '@shared/modules/uploader/models/file.model';
import Timeout = NodeJS.Timeout;
import { DeliveryReturnDateFacade } from '@features/client/order-workflow/facades/delivery-return-date.facade';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-scans-download-status',
  templateUrl: './scans-download-status.component.html',
  styleUrls: ['./scans-download-status.component.scss'],
  imports: [TranslatePipe],
})
export class ScansDownloadStatusComponent implements OnInit {
  @Output() public downloadedScans: EventEmitter<VaporFile[]> = new EventEmitter<VaporFile[]>();

  public scansDownloadLeft: number;
  private localInterval: Timeout;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly orderWorkflowFacade: OrderWorkflowFacade,
    private readonly deliveryReturnDateFacade: DeliveryReturnDateFacade,
  ) {}

  public ngOnInit(): void {
    this.orderWorkflowFacade
      .getActiveStep()
      .pipe(first())
      .subscribe((step) => {
        if (step === OrderWorkflowStep.deliveryReturnDate) {
          this.checkDownloadStatus();
        }
      });

    this.orderWorkflowFacade
      .callDownloadStatusMethod()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        clearInterval(this.localInterval);

        this.checkDownloadStatus();
      });

    this.destroyRef.onDestroy(() => {
      return clearInterval(this.localInterval);
    });
  }

  private checkDownloadStatus(): void {
    this.getDownloadStatus();

    this.localInterval = setInterval(() => {
      this.getDownloadStatus();
    }, 10000);
  }

  private getDownloadStatus(): void {
    setTimeout(() => {
      this.orderWorkflowFacade
        .getDownloadStatus()
        .pipe(first())
        .subscribe((response) => {
          this.scansDownloadLeft = response.cases_in_queue;

          if (!this.scansDownloadLeft) {
            clearInterval(this.localInterval);

            this.deliveryReturnDateFacade
              .fetchDeliveryReturnDateData()
              .pipe(first(), delay(2000))
              .subscribe((order) => {
                this.downloadedScans.emit(order.scanFiles);
              });
          }
        });
    }, 2000);
  }
}
